import React from 'react';

import { Container, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { BREAKPOINTS_VALUES, useIsWidthUp } from '../../theme';
import { Background } from '../../types';
import { splitIntoChunks } from '../../utils/helpers';
import Flipper from '../Flipper/Flipper';
import TeamMember from '../TeamMember/TeamMember';
import useStyles from './styles';

const swiperSetting: SwiperOptions = {
  slidesPerView: 2,
  spaceBetween: 20,
  pagination: {
    clickable: true,
  },
  breakpoints: {
    [BREAKPOINTS_VALUES.sm]: {
      slidesPerView: 3,
    },
  },
};

const MeetTheTeam = ({ data }) => {
  const isDark = data?.background === Background.Dark;
  const classes = useStyles(isDark)();

  const isMobile = !useIsWidthUp('md');

  return (
    <div className={classes.wrapper}>
      <Container>
        <Typography variant={'h2'} className={classes.title}>
          {data?.heading}
        </Typography>
        {!isMobile ? (
          <div className={classes.cardsWrapper}>
            {data?.members?.map((member) =>
              member?.secondary_image ? (
                <Flipper key={member.id} wrapperClass={classes.card}>
                  <TeamMember
                    title={member.name}
                    jobTitle={member.employee_job_title}
                    imageUrl={member.avatar}
                    isDark={!isDark}
                    link={member.linkedin_url}
                    linkTitle="Linkedin"
                  />
                  <TeamMember
                    title={member.name}
                    jobTitle={member.employee_job_title}
                    imageUrl={member.secondary_image}
                    isDark={!isDark}
                    link={member.linkedin_url}
                    linkTitle="Linkedin"
                  />
                </Flipper>
              ) : (
                <div className={classes.card}>
                  <TeamMember
                    title={member.name}
                    jobTitle={member.employee_job_title}
                    imageUrl={member.avatar}
                    isDark={!isDark}
                    link={member.linkedin_url}
                    linkTitle="Linkedin"
                    wrapperClass={classes.cardContent}
                  />
                </div>
              ),
            )}
          </div>
        ) : (
          <Swiper {...swiperSetting}>
            {splitIntoChunks(data?.members || [], 2).map((chunk, index) => (
              <SwiperSlide key={index}>
                <div>
                  {chunk.map((member) =>
                    member?.secondary_image ? (
                      <Flipper key={member.id} wrapperClass={classes.card}>
                        <TeamMember
                          title={member.name}
                          jobTitle={member.employee_job_title}
                          imageUrl={member.avatar}
                          isDark={!isDark}
                          link={member.linkedin_url}
                          linkTitle="Linkedin"
                        />
                        <TeamMember
                          title={member.name}
                          jobTitle={member.employee_job_title}
                          imageUrl={member.secondary_image}
                          isDark={!isDark}
                          link={member.linkedin_url}
                          linkTitle="Linkedin"
                        />
                      </Flipper>
                    ) : (
                      <div className={classes.card}>
                        <TeamMember
                          title={member.name}
                          jobTitle={member.employee_job_title}
                          imageUrl={member.avatar}
                          isDark={!isDark}
                          link={member.linkedin_url}
                          linkTitle="Linkedin"
                          wrapperClass={classes.cardContent}
                        />
                      </div>
                    ),
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Container>
    </div>
  );
};

export default MeetTheTeam;
